export const AVAILABILITY_TYPES = { AVAILABLE: 'available', UNAVAILABLE: 'unavailable' };

// per design
export const DEFAULT_START_TIME = '08:00';
export const DEFAULT_END_TIME = '18:00';
